import React from 'react';
import Aux from '../../Hoc/Aux/Aux';
import Hero from '../UI/Hero/Hero';
import parttimeImg from '../../Assets/Images/img1.png';
import Footer from '../Footer/Footer';

const parttime = (props) => {
    return(
        <Aux>
            <Hero title="18 Weeks Part-Time Courses"
                  classType="hero-overview"
                  img={parttimeImg}
            />
            <section></section>
            <Aux>
                <Footer />
            </Aux>
        </Aux>
    )
};

export default parttime;


// WEBPACK FOOTER //
// ./src/Components/PartTime/PartTime.js